<script>
export default {
	props: {
		title: {
			type: String,
			default: "untitled"
		},
		group: {
			type: String,
			default: ""
		}
	},
	data (){
		return {
			active: "/"
		}
	},
	mounted (){
		this.$watch("group", nval=>{
			this.active = nval
		}, {
			immediate: true
		})
	},
	methods: {
		handleTabChange (name){
			this.$router.push(name).catch(e=>e)
		}
	}
}
</script>
<template lang="pug">
.app-page(v-on="$listeners")
    .container
        slot
    .footer
        van-tabbar(v-model="active" @change="handleTabChange" style="box-shadow: 1px 1px 7px #ccc ;")
            van-tabbar-item(icon="wap-home" name="/home") 首页
            van-tabbar-item(icon="manager" name="/my") 我的
</template>